import { useState, useEffect, useRef } from 'react';
import benchatService from '../../../service/benchatService';
import { useAsyncSubscription } from '../../../hooks';

/**
 * @typedef Params
 * @prop {string} userId - when login, it is current user ID, or request session ID
 * @prop {string[]} topics - benchat topics for query api
 * @prop {string} platform - benchat platform for query api
 */

/**
 * Providing useAsyncSubscription initial subsrciptions
 * Using hook is for data store
 * @param {Params} param
 */
function useBenchatSubscriptions({ userId, topics, platform }) {
  const initialProps = useRef({ userId, topics, platform });
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const {
    userRef,
    currentSubscriptions,
    subscriptionStatus,
    hasSubscribed,
    startPolling,
  } = useAsyncSubscription({
    userId,
    platform,
    subscriptions,
    topics,
  });

  useEffect(() => {
    const getSubscriptions = async () => {
      setIsLoaded(false);
      try {
        const res = await benchatService.getSubscriptions(
          initialProps.current.userId,
          initialProps.current.topics,
          initialProps.current.platform,
        );
        setSubscriptions(res.data?.subscriptions ?? []);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoaded(true);
      }
    };

    getSubscriptions();
  }, []);

  useEffect(() => {
    setSubscriptions(currentSubscriptions);
  }, [currentSubscriptions]);

  return {
    subscriptions,
    isLoaded,
    userRef,
    hasSubscribed,
    startPolling,
    subscriptionStatus,
  };
}

export default useBenchatSubscriptions;
